













import Vue from 'vue'
export default Vue.extend({
    props: {
        color: {
            type: String,
            default: '#6142B0'
        },
        denominator: {
            type: Number,
            required: true
        },
        height: {
            type: [Number, String],
            default: '18px'
        },
        innerHeight: {
            type: [Number, String],
            default: '16px'
        },
        numerator: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            default: null
        },
        width: {
            type: [Number, String],
            default: '250px'
        }
    },
    computed: {
        barSize(): number {
            return (this.numerator / this.denominator) * 100
        }
    }
})
